const articleHero = {
  displayField: 'asdf',
  name: 'zzz',
  description: '',
  fields: [
    {
      id: 'asdf',
      name: 'asdf',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: true
    }
  ],
  sys: {
    id: 'articleHero',
    version: 24,
    updatedAt: '2023-06-06T15:16:51.732Z'
  }
};
export default articleHero;